// Components that are only used in Practice & Assesssment related parts.
// Please keep the lines sorted to avoid merge conflicts.
import { defineAsyncComponent } from "vue";

export const AssessmentTask = defineAsyncComponent(async () => (await import("./static/PracticeAndAssessment")).AssessmentTask);
export const PracticeGame = defineAsyncComponent(async () => (await import("./static/PracticeAndAssessment")).PracticeGame);
export const Vocabulary = defineAsyncComponent(async () => (await import("./static/PracticeAndAssessment")).Vocabulary);
export const AssessmentReview = defineAsyncComponent(async () => (await import("./static/PracticeAndAssessment")).AssessmentReview);
